/**
 * Local copies of ks-common order enums.
 *
 * The app must not value-import from the 'ks-common' barrel: its index pulls
 * in NestJS server-only modules and breaks the webpack browser build.
 * Interfaces are fine (type-only imports are erased), but enums are runtime
 * values, so they live here. orderEnums.test.ts pins these against the pure
 * leaf files in ks-common/dist so they cannot drift.
 */

export enum OrderStatusEnum {
  Confirmed = 0,
  Updated = 1,
  Cancelled = 5,
}

export enum CancelBlockReasonEnum {
  None = 0,
  AlreadyCancelled = 1,
  Donation = 2,
  AdminLocked = 3,
  ProductInProgress = 4,
  WithinCutoff = 5,
  ManualRefundRequired = 6,
}
